// ==========================================
// SAPUNA SHOP ALL COLLECTION
// Full Shopify integration with price sync and add to cart
// ==========================================

(function() {
  'use strict';
  
  // Product configurations for price sync - all 41 products (no compare prices)
  const productConfigs = [
    { variantId: 45861426561160, handle: 'coconut-milk-avocado-body-scrub', priceElement: 'price-1', defaultPrice: 24.90 },
    { variantId: 45861444386952, handle: 'floral-charm-exfoliating-body-scrub', priceElement: 'price-2', defaultPrice: 24.90 },
    { variantId: 45861446221960, handle: 'pomegranate-peach-exfoliating-body-scrub', priceElement: 'price-3', defaultPrice: 24.90 },
    { variantId: 45861447696520, handle: 'strawberry-passion-exfoliating-body-scrub', priceElement: 'price-4', defaultPrice: 24.90 },
    { variantId: 45861447860360, handle: 'green-tea-exfoliating-body-scrub', priceElement: 'price-5', defaultPrice: 24.90 },
    { variantId: 45925849989256, handle: 'mango-lychee-exfoliating-body-scrub', priceElement: 'price-6', defaultPrice: 18.00 },
    { variantId: 45925850054792, handle: 'white-musk-exfoliating-body-scrub', priceElement: 'price-7', defaultPrice: 18.00 },
    { variantId: 45861438718088, handle: 'floral-charm-hydrating-body-lotion', priceElement: 'price-8', defaultPrice: 22.90 },
    { variantId: 45861439799432, handle: 'pomegranate-peach-hydrating-body-lotion', priceElement: 'price-9', defaultPrice: 22.90 },
    { variantId: 45861441470600, handle: 'strawberry-passion-hydrating-body-lotion', priceElement: 'price-10', defaultPrice: 22.90 },
    { variantId: 45861443043464, handle: 'green-tea-hydrating-body-lotion', priceElement: 'price-11', defaultPrice: 22.90 },
    { variantId: 45925845074056, handle: 'mango-lychee-hydrating-body-lotion', priceElement: 'price-12', defaultPrice: 15.00 },
    { variantId: 45925845237896, handle: 'white-musk-hydrating-body-lotion', priceElement: 'price-13', defaultPrice: 15.00 },
    { variantId: 45925791826056, handle: 'pomegranate-peach-body-butter', priceElement: 'price-14', defaultPrice: 15.00 },
    { variantId: 45925792088200, handle: 'green-tea-body-butter', priceElement: 'price-15', defaultPrice: 15.00 },
    { variantId: 45925792481416, handle: 'mango-lychee-body-butter', priceElement: 'price-16', defaultPrice: 15.00 },
    { variantId: 45925810208904, handle: 'lavender-vanilla-body-oil', priceElement: 'price-17', defaultPrice: 25.00 },
    { variantId: 45925810438280, handle: 'white-musk-body-oil', priceElement: 'price-18', defaultPrice: 25.00 },
    { variantId: 45925811617928, handle: 'mango-lychee-body-oil', priceElement: 'price-19', defaultPrice: 25.00 },
    { variantId: 45925811978376, handle: 'green-tea-body-oil', priceElement: 'price-20', defaultPrice: 25.00 },
    { variantId: 45925812011144, handle: 'strawberry-passion-body-oil', priceElement: 'price-21', defaultPrice: 25.00 },
    { variantId: 45925812043912, handle: 'lebanese-cedar-oud-body-oil', priceElement: 'price-22', defaultPrice: 25.00 },
    { variantId: 45925825216648, handle: 'coconut-milk-avocado-body-oil', priceElement: 'price-23', defaultPrice: 25.00 },
    { variantId: 45925836816520, handle: 'calm-sense-toner', priceElement: 'price-24', defaultPrice: 15.00 },
    { variantId: 45925836914824, handle: 'hydra-bloom-toner', priceElement: 'price-25', defaultPrice: 15.00 },
    { variantId: 45925837045896, handle: 'radiance-reveal-toner', priceElement: 'price-26', defaultPrice: 15.00 },
    { variantId: 45861449138312, handle: 'hydrating-micellar-cleansing-water', priceElement: 'price-27', defaultPrice: 9.00 },
    { variantId: 45861475647624, handle: 'gentle-foaming-cleanser-sensitive-skin', priceElement: 'price-28', defaultPrice: 12.00 },
    { variantId: 45861480956040, handle: 'salicylic-acid-foaming-cleanser-acne-skin', priceElement: 'price-29', defaultPrice: 10.00 },
    { variantId: 45861448384648, handle: 'probioglow-night-repair-cream', priceElement: 'price-30', defaultPrice: 30.00 },
    { variantId: 45861449269384, handle: 'berryglow-antioxidant-day-cream', priceElement: 'price-31', defaultPrice: 25.00 },
    { variantId: 45861449629832, handle: 'sensiglow-calming-face-cream', priceElement: 'price-32', defaultPrice: 30.00 },
    { variantId: 45861450252424, handle: 'clearderm-revive-acne-serum', priceElement: 'price-33', defaultPrice: 45.00 },
    { variantId: 45861450973320, handle: 'hydracalm-barrier-repair-serum', priceElement: 'price-34', defaultPrice: 30.00 },
    { variantId: 45861452152968, handle: 'c-power-glow-vitamin-c-serum', priceElement: 'price-35', defaultPrice: 35.00 },
    { variantId: 45861452382344, handle: 'trueglow-brightening-pigmentation-serum', priceElement: 'price-36', defaultPrice: 50.00 },
    { variantId: 45861460443272, handle: 'agereversal-complex-anti-aging-serum', priceElement: 'price-37', defaultPrice: 50.00 },
    { variantId: 45925837439112, handle: 'peony-oat-kernel-baby-lotion', priceElement: 'price-38', defaultPrice: 12.00 },
    { variantId: 45925837471880, handle: 'peony-chamomile-baby-oil', priceElement: 'price-39', defaultPrice: 20.00 },
    { variantId: 45925843927176, handle: 'peony-baby-shampoo-wash', priceElement: 'price-40', defaultPrice: 12.00 },
    { variantId: 45925844418696, handle: 'baby-diaper-rash-cream', priceElement: 'price-41', defaultPrice: 12.00 }
  ];

  // Helper function
  function formatMoney(amount) {
    return `$${amount.toFixed(2)}`;
  }

  // Card click redirect (except on add to cart button)
  function initCardRedirects() {
    document.querySelectorAll('.sapuna-product-card').forEach(card => {
      const productUrl = card.getAttribute('data-handle');
      
      card.addEventListener('click', function(e) {
        if (e.target.closest('.sapuna-add-to-cart')) {
          return;
        }
        if (productUrl) {
          window.location.href = productUrl;
        }
      });
    });
  }

  // Sync prices from Shopify
  async function syncProductPrice(config) {
    try {
      const response = await fetch(`/products/${config.handle}.js`);
      if (!response.ok) return;
      const product = await response.json();
      const variant = product.variants.find(v => v.id === config.variantId);
      
      if (variant) {
        const price = variant.price / 100;
        const priceEl = document.getElementById(config.priceElement);
        
        if (priceEl) priceEl.textContent = formatMoney(price);
      }
    } catch (error) {
      console.error(`Failed to sync ${config.handle}:`, error);
    }
  }

  async function syncAllPrices() {
    for (const config of productConfigs) {
      await syncProductPrice(config);
    }
  }

  // Add to cart functionality
  async function addToCart(variantId, title, image, handle) {
    try {
      if (typeof window.addToCart === 'function') {
        await window.addToCart({ 
          variantId: variantId, 
          quantity: 1, 
          title: title, 
          image: image, 
          handle: handle 
        });
      } else {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json', 
            'Accept': 'application/json' 
          },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        
        if (!response.ok) throw new Error('Failed to add');
        
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        }
        
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
      return true;
    } catch (error) {
      console.error('Add to cart error:', error);
      throw error;
    }
  }

  function initAddToCartButtons() {
    document.querySelectorAll('.sapuna-add-to-cart').forEach(btn => {
      btn.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const variantId = parseInt(this.getAttribute('data-variant-id'));
        const card = this.closest('.sapuna-product-card');
        const title = card.getAttribute('data-title');
        const image = card.getAttribute('data-image');
        const handle = card.getAttribute('data-handle').replace('/products/', '');
        
        const originalText = this.innerHTML;
        this.disabled = true;
        this.innerHTML = 'Adding...';
        
        try {
          await addToCart(variantId, title, image, handle);
          this.innerHTML = '✓ Added!';
          setTimeout(() => {
            this.innerHTML = originalText;
            this.disabled = false;
          }, 1500);
        } catch (error) {
          this.innerHTML = 'Error!';
          setTimeout(() => {
            this.innerHTML = originalText;
            this.disabled = false;
          }, 1500);
        }
      });
    });
  }

  // Initialize everything
  function init() {
    initCardRedirects();
    initAddToCartButtons();
    syncAllPrices();
    
    // Auto-sync every 5 minutes
    setInterval(syncAllPrices, 300000);
    
    console.log('Sapuna Shop All Collection - Initialized (41 products)');
  }
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();